export default __webpack_public_path__ + "static/media/rnr-sports-table-27-cn.85209dd0.webp";